:host {
  /**
   * @prop --c-menu-text-color: Menu text color
   * @prop --c-menu-text-color-active: Menu active text color
   * @prop --c-menu-background-color-hover: Menu hover background color
   * @prop --c-menu-outline-color: Menu outline color
   */
  --_c-menu-text-color: var(--c-menu-text-color, var(--c-text-system));
  --_c-menu-text-color-active: var(
    --c-menu-text-color-active,
    var(--c-primary-600)
  );
  --_c-menu-background-color-hover: var(
    --c-menu-background-color-hover,
    var(--c-primary-200)
  );
  --_c-menu-outline-color: var(--c-menu-outline-color, var(--c-primary-600));

  // private
  --_c-menu-header-height: 38px;
  --_c-menu-padding: 0 14px;

  border-radius: 4px;
  display: block;
  font-size: 14px;
  position: relative;
  user-select: none;
  height: fit-content;

  button {
    background: none;
    border-radius: 4px;
    border: none;
    color: var(--_c-menu-text-color);
    cursor: pointer;
    display: block;
    font-family: var(--c-font-family);
    margin: 0;
    padding: var(--_c-menu-padding);
    position: relative;
    user-select: none;

    &:focus {
      outline: 2px var(--_c-menu-outline-color) solid;
      outline-offset: 2px;
    }

    @supports selector(:focus-visible) {
      &:focus {
        outline: none;
      }
    }

    &:focus-visible {
      outline: 2px var(--_c-menu-outline-color) solid;
      outline-offset: 2px;
    }

    &:hover {
      background-color: var(--_c-menu-background-color-hover);
    }
  }

  .c-menu__icon {
    line-height: 20px;
    transition: transform 0.25s;

    &--rotated {
      transform: rotate(180deg);
    }
  }

  .c-menu__header {
    display: flex;
    flex: 1 1 auto;
    margin-left: 0;
    align-items: center;
    gap: 8px;
    height: var(--_c-menu-header-height);
  }
}

:host(.c-menu--custom) {
  --_c-menu-padding: 0;
  --_c-menu-background-color-hover: transparent !important;

  background: transparent !important;
}

:host(.c-menu--small) {
  --_c-menu-header-height: 32px;
}

:host(.c-menu--active) c-icon,
:host(:hover) c-icon {
  color: var(--_c-menu-text-color-active);
}

:host(.c-menu--no-hover) {
  --_c-menu-background-color-hover: transparent !important;
}

.c-menu-overlay {
  position: fixed;
  inset: 0;
  pointer-events: none;

  &__content {
    position: relative;
    height: 100%;
    width: 100%;
  }
}
